import React from "react";

const SECTIONS = [
  ["Information We Collect", "We do not collect any personal information. All invoice data is processed locally in your browser and never uploaded to our servers."],
  ["Data Storage", "Your invoice data is stored locally on your device using the browser's local storage. Nothing is uploaded or synced."],
  ["Third-Party Services", "We use minimal privacy-friendly analytics to count anonymous page visits. We do not sell or share any data."],
  ["Cookies", "We use only essential cookies to remember your theme preference. No tracking cookies."],
  ["Contact", "If you have any questions about this Privacy Policy, please email us at support@simpleinvoice.com."],
];

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold mb-3">Legal</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">Privacy Policy</h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated: February 5, 2026</p>
        <p className="mt-6 text-muted-foreground leading-relaxed">We respect your privacy and are committed to protecting it through our compliance with this policy.</p>
      </div>
      <div className="space-y-8">
        {SECTIONS.map(([t, d], i) => (
          <section key={t}>
            <h2 className="font-heading text-lg font-semibold">{i + 1}. {t}</h2>
            <p className="mt-2 text-muted-foreground leading-relaxed">{d}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
